import React, { Component } from 'react';
import { observer } from 'mobx-react';
import classnames from 'classnames';

import Form from 'components/Util/Inputs/Form';
import InputM from 'components/Util/Inputs/InputM';
import Button from 'components/Util/Buttons/LightBackground/MediumPrimaryButton';

import QuarantineConfig from './QuarantineConfig';

import Store from 'models/Form';

import styles from 'styles/Dashboard/Base';

@observer
export default class Config extends Component {
  onSuccess = (data) => {
    window.location = `/home/settings/unsubscribe_groups/${data.id}`;
  }

  render() {
    const { unsubscribeGroup, action, store, method } = this.props;

    return (
      <React.Fragment>
        <h5 className={classnames(styles.p2, 'fw-bold')}>Configuration</h5>
        <Form method={method} action={action} onSuccess={this.onSuccess} store={store}>
          <label className={classnames(styles.Label)}>
            <p>Name</p>
            <p className={classnames(styles.InputDescription, 'mb-1')}>This will be displayed to your users when they modify their subscription settings.</p>
            <InputM
              disabled={unsubscribeGroup.isGlobalUnsubscribe}
              defaultValue={unsubscribeGroup.name}
              className={classnames(styles.InputWidth, 'mb-2')}
              name='name'
              placeholder='Name'
              store={store} />
          </label>

          { unsubscribeGroup.isGlobalUnsubscribe && <QuarantineConfig unsubscribeGroup={unsubscribeGroup} store={store} /> }

          <div>
            <Button>{ method === 'put' ? 'Update' : 'Create' }</Button>
            <InputM className={classnames(styles.ShowInputMessage, 'float-start')} type='hidden' name='id' value={unsubscribeGroup.id} store={store} />
          </div>
        </Form>
      </React.Fragment>
    );
  }
}
